import { UitkEGMapsMarkerType, UitkEGMapsPropertyStatus, UitkEGMapsQualifier } from 'uitk-react-map';

export const iconMap = {
  AIRPORT: {
    type: UitkEGMapsMarkerType.PLACE,
    qualifiers: [UitkEGMapsQualifier.AIRPORT],
    status: UitkEGMapsPropertyStatus.UNKNOWN,
  },
  SOLD_OUT: {
    type: UitkEGMapsMarkerType.PROPERTY,
    qualifiers: [UitkEGMapsQualifier.NOT_CLUSTERED],
    status: UitkEGMapsPropertyStatus.SOLD_OUT,
  },
  LANDMARK: {
    type: UitkEGMapsMarkerType.PLACE,
    status: UitkEGMapsPropertyStatus.UNKNOWN,
  },
  HOTEL: {
    type: UitkEGMapsMarkerType.PROPERTY,
    status: UitkEGMapsPropertyStatus.AVAILABLE,
  },
};
